import type { LinkClickEvent } from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import { FIELDS_LEARN_MORE_LINKS } from '../../../../../common/constants/index.tsx';
import { openInNewTabLinkClickEventHandler } from '../../../../../common/utils/link-handler/index.tsx';
import { RENDER_BATCH_SIZE_DENOMINATOR } from './constants.tsx';

const isFieldWithLearnMoreLink = (
	gqlType: string,
): gqlType is keyof typeof FIELDS_LEARN_MORE_LINKS =>
	Object.keys(FIELDS_LEARN_MORE_LINKS).includes(gqlType);

export const getHelpTextUrl = (gqlType: string): string | undefined => {
	if (isFieldWithLearnMoreLink(gqlType)) {
		return FIELDS_LEARN_MORE_LINKS[gqlType];
	}

	return undefined;
};

export const getOnLinkClickEvent = (gqlType: string): LinkClickEvent | undefined => {
	if (isFieldWithLearnMoreLink(gqlType)) {
		return openInNewTabLinkClickEventHandler;
	}
	return undefined;
};

export const getFieldsToRenderInOneBatch = (totalFields: number) =>
	Math.max(Math.floor(totalFields / RENDER_BATCH_SIZE_DENOMINATOR), 10);
